// extracted by mini-css-extract-plugin
export default {"appNotification":"NotificationStyles_appNotification__yOtGq"};